import axios from "axios";

const instance = axios.create({
    baseURL: "http://127.0.0.1:8000/api/", // Cambia esta URL si es necesario
        headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

// Interceptores de solicitudes (opcional)
instance.interceptors.request.use(
    (config) => {
    // Puedes agregar lógica adicional, como tokens de autenticación
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptores de respuestas (opcional)
instance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        return Promise.reject(error.response || error.message);
    }
);

export default instance;
